module.exports = __webpack_public_path__ + "static/media/warranty.c0e3ac3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/benefits/warranty.png
// module id = 1972
// module chunks = 0